import {
  RACBreadcrumb,
  RACBreadcrumbLinkType,
  Grid,
} from '@rentacenter/racstrap';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { customerStyles } from '../customerStyles';

export const Breadcrumb = () => {
  const location = useLocation();
  const classes = customerStyles();

  const links: RACBreadcrumbLinkType[] = useMemo(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const accumulatedPath: string[] = [];

    return pathSegments.map((segment, index) => {
      let displaySegment = segment;

      if (index === 0 && segment === 'csm') {
        displaySegment = 'operations';
      }

      accumulatedPath.push(segment);
      let href = '/' + accumulatedPath.join('/');

      if (segment === 'info') {
        href = '/csm/search';
        return { href, label: 'info' };
      }

      if (segment === 'search') {
        return { href, label: 'Search all Incidents' };
      }

      const label =
        displaySegment.charAt(0).toUpperCase() + displaySegment.slice(1);
      return { href, label };
    });
  }, [location.pathname]);

  return (
    <React.Fragment>
      <Grid className={classes.parentclass}>
        <Grid item md={12} className={classes.flexratio}>
          <RACBreadcrumb links={links} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
